/**
 * Out-of-Stock Notification Handler
 * EthicSport customization
 *
 * Handles back-in-stock notification subscriptions
 * Endpoint: Odoo stage API
 */

(function () {
  const MODAL_ID = "oos-notify-modal";
  const API_BASE = "https://odoo-stage.ostrovit.com/api/products/code/";

  const modal = document.getElementById(MODAL_ID);
  if (!modal) return;

  const form = document.getElementById("oos-notify-form");
  if (!form) return;

  // bind tylko raz
  if (form.dataset.oosBound === "1") return;
  form.dataset.oosBound = "1";

  const titleLine = document.getElementById("oos-notify-product");
  const submitBtn = form.querySelector('button[type="submit"]');

  const successEl = form.querySelector(".oos-success");
  const alreadyEl = form.querySelector(".oos-already");
  const errorEl = form.querySelector(".oos-error");

  // ---------- helpers ----------
  const log = (...args) => console.log("[OOS]", ...args);
  const warn = (...args) => console.warn("[OOS]", ...args);
  const errLog = (...args) => console.error("[OOS]", ...args);

  function hide(el) {
    if (el) el.hidden = true;
  }
  function show(el) {
    if (el) el.hidden = false;
  }
  function hideAll() {
    hide(successEl);
    hide(alreadyEl);
    hide(errorEl);
  }
  function setLoading(isLoading) {
    if (!submitBtn) return;
    if (isLoading) submitBtn.setAttribute("disabled", "disabled");
    else submitBtn.removeAttribute("disabled");
  }
  function visibleState() {
    return {
      success: successEl ? !successEl.hidden : null,
      already: alreadyEl ? !alreadyEl.hidden : null,
      error: errorEl ? !errorEl.hidden : null,
    };
  }

  function openModal(btn) {
    const productTitle = btn.dataset.productTitle || "";
    const variantTitle = btn.dataset.variantTitle || "";

    modal.hidden = false;
    document.body.classList.add("oos-modal-open");

    if (titleLine) {
      titleLine.textContent =
        variantTitle && variantTitle !== "Default Title"
          ? productTitle + " \u2014 " + variantTitle
          : productTitle;
    }

    // reset fields
    if (form.email) form.email.value = "";
    if (form.consent) form.consent.checked = false;

    // hidden fields
    if (form.product_id) form.product_id.value = btn.dataset.productId || "";
    if (form.variant_id) form.variant_id.value = btn.dataset.variantId || "";
    if (form.product_code) form.product_code.value = btn.dataset.productCode || "";
    if (form.product_title) form.product_title.value = productTitle;
    if (form.variant_title) form.variant_title.value = variantTitle;
    if (form.page_url) form.page_url.value = window.location.href;

    hideAll();
    setLoading(false);

    log("open modal", {
      productTitle,
      variantTitle,
      productCode: form.product_code?.value,
      elements: { success: !!successEl, already: !!alreadyEl, error: !!errorEl },
    });
  }

  function closeModal() {
    modal.hidden = true;
    document.body.classList.remove("oos-modal-open");
    log("close modal");
  }

  // ---------- events ----------
  document.addEventListener(
    "click",
    function (e) {
      var openBtn = e.target.closest(".js-oos-notify-open");
      if (openBtn) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        openModal(openBtn);
        return;
      }

      if (e.target.closest("[data-oos-close]")) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        closeModal();
      }
    },
    true,
  );

  document.addEventListener(
    "keydown",
    function (e) {
      if (e.key === "Escape" && !modal.hidden) closeModal();
    },
    true,
  );

  form.addEventListener(
    "submit",
    async function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      hideAll();

      var email = (form.email?.value || "").trim();
      var consent = !!form.consent?.checked;
      var code = (form.product_code?.value || "").trim();

      log("submit start", { email: email ? email : "(empty)", consent: consent, code: code });

      if (!email || !consent || !code) {
        warn("validation failed", { email: !!email, consent: consent, code: !!code });
        show(errorEl);
        log("ui after validation fail", visibleState());
        return;
      }

      setLoading(true);

      var url = API_BASE + encodeURIComponent(code) + "/alert";
      log("fetch ->", url);

      try {
        var res = await fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams({ email: email }),
        });

        log("fetch response", { status: res.status, ok: res.ok, type: res.type });

        // DEBUG: if you see status=0 and/or type="opaque", it's a CORS / proxy issue
        if (res.type === "opaque" || res.status === 0) {
          warn(
            "response is opaque/status=0 -> likely CORS/proxy issue. Browser blocks reading status.",
          );
        }

        if (res.status === 200) {
          log("branch: 200 success");
          hideAll();
          show(successEl);
          setLoading(false);
          log("ui after 200", visibleState());
          return;
        }

        if (res.status === 400) {
          log("branch: 400 already");
          hideAll();
          show(alreadyEl);
          setLoading(false);
          log("ui after 400", visibleState());
          return;
        }

        log("branch: default (error)", res.status);
        hideAll();
        show(errorEl);
        setLoading(false);
        log("ui after default", visibleState());
      } catch (fetchErr) {
        // CORS / network / adblock / dns / timeout etc.
        errLog("fetch failed (catch)", fetchErr);
        hideAll();
        show(errorEl);
        setLoading(false);
        log("ui after catch", visibleState());
      }
    },
    true,
  );

  hideAll();
  log("init", {
    modal: !!modal,
    form: !!form,
    elements: { success: !!successEl, already: !!alreadyEl, error: !!errorEl },
  });
})();
